import { FeatureFlags } from '~constants/featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export default function useShouldShowHaulerRateCard() {
  const showHaulerRateTypeCardFeatureFlagEnabled = useFeatureFlag({
    featureFlagKey: FeatureFlags.showHaulerRateTypeCard,
  });
  const tomlinsonOrderModalFeatureFlagEnabled = useFeatureFlag({
    featureFlagKey: FeatureFlags.tomlinsonOrderModal,
  });

  return (
    showHaulerRateTypeCardFeatureFlagEnabled || tomlinsonOrderModalFeatureFlagEnabled
  );
}
